module.exports = __webpack_public_path__ + "img/invoice-gray.167b1bd9.svg";